export enum ERoles {
  Superadmin = 'SUPERADMIN',
  Editor = 'Editor',
  Verificator = 'Verificator',
}
